module.exports = __webpack_public_path__ + "img/weatherpedia-pwa8.a124254b.jpg";